// src/context/AuthContext.jsx
import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const API_URL = "https://blog-sectores-econimia.onrender.com";

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const storedUser = localStorage.getItem("user");

    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch {
        console.warn("⚠️ Datos de usuario corruptos, limpiando almacenamiento...");
        setUser(null);
        localStorage.removeItem("user");
        localStorage.removeItem("access_token");
      }
    }

    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const res = await axios.post(`${API_URL}/auth/`, { email, password });
      const { access_token, user } = res.data;
      console.log("💎 Membership level del backend:", user.membership_level);
      if (!user) {
        console.error("❌ Backend no devolvió el objeto user");
        return false;
      }
      console.log("🔍 Antes de validar membership_level:", user.membership_level);

      // Guardar token y usuario en localStorage
      localStorage.setItem("access_token", access_token);
      localStorage.setItem("user", JSON.stringify(user));

      // Guardar en estado
      setUser(user);

      console.log("✅ Login exitoso:", user);
      return true;
    } catch (err) {
      console.error("❌ Error de login:", err.response?.data || err.message);
      return false;
    }
  };


  const logout = () => {
    console.log("👋 Cerrando sesión...");
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_role");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// 🔹 Hook personalizado para usar el contexto
export const useAuth = () => useContext(AuthContext);
